import React from 'react';
import { CTAButton } from './CTAButton';
export function SolutionSection() {
  return <section className="py-20 px-4 bg-white text-center" data-id="element-170">
      <div className="max-w-4xl mx-auto" data-id="element-171">
        <p className="text-2xl md:text-3xl font-bold text-gray-600 mb-4" data-id="element-172">
          Acá es donde entra:
        </p>
        <h2 className="text-5xl md:text-7xl font-black text-black mb-10 uppercase tracking-tight" data-id="element-173">
          👉 EL SISTEMA DE{' '}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 to-yellow-600" data-id="element-174">
            0 A VENTAS
          </span>{' '}
          EN 30 DÍAS
        </h2>

        <div className="bg-gray-50 border-4 border-black rounded-2xl p-8 md:p-12 mb-12 shadow-[8px_8px_0_0_rgba(0,0,0,1)]" data-id="element-175">
          <p className="text-2xl md:text-3xl font-black mb-8" data-id="element-176">
            Un sistema completo que combina:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 text-left max-w-2xl mx-auto" data-id="element-177">
            <div className="flex items-center gap-4 bg-white p-4 rounded-xl border-2 border-gray-200 shadow-sm" data-id="element-178">
              <span className="text-3xl" data-id="element-179">✔</span>
              <span className="text-xl font-bold" data-id="element-180">Qué hacer cada día</span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-xl border-2 border-gray-200 shadow-sm" data-id="element-181">
              <span className="text-3xl" data-id="element-182">✔</span>
              <span className="text-xl font-bold" data-id="element-183">Qué publicar</span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-xl border-2 border-gray-200 shadow-sm" data-id="element-184">
              <span className="text-3xl" data-id="element-185">✔</span>
              <span className="text-xl font-bold" data-id="element-186">Qué decir</span>
            </div>
            <div className="flex items-center gap-4 bg-white p-4 rounded-xl border-2 border-gray-200 shadow-sm" data-id="element-187">
              <span className="text-3xl" data-id="element-188">✔</span>
              <span className="text-xl font-bold" data-id="element-189">Cómo convertir</span>
            </div>
          </div>
        </div>

        <CTAButton text="ACCEDER AL SISTEMA" data-id="element-190" />
      </div>
    </section>;
}